import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './dumpster-rental.css'

const DumpsterRental = (props) => {
  return (
    <div className="dumpster-rental-container1">
      <Helmet>
        <title>Dumpster Rental - Panda Demolition &amp; Disposal</title>
        <meta
          property="og:title"
          content="Dumpster Rental - Panda Demolition & Disposal"
        />
        <link
          rel="canonical"
          href="https://www.pandademolition.com/dumpster-rental"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-order">
        <div className="hero-video-wrapper">
          <video
            src="https://videos.pexels.com/video-files/4376234/4376234-hd_1920_1080_24fps.mp4"
            loop="true"
            muted="true"
            poster="https://images.pexels.com/videos/4376234/pictures/preview-0.jpg"
            autoPlay="true"
            playsInline="true"
            className="hero-video"
          ></video>
          <div className="dumpster-rental-hero-overlay"></div>
        </div>
        <div className="hero-content-container">
          <div className="hero-text-box">
            <h1 className="hero-title">Panda Demolition &amp; Disposal</h1>
            <p className="hero-subtitle">
              Heavy-duty dumpster rentals for projects that mean business.
              Instant booking, transparent pricing, and rapid delivery.
            </p>
          </div>
          <form
            action="/contact"
            method="GET"
            data-form-id="8406d916-8ffa-478b-b2b7-3bd034e1ed8c"
            className="hero-quick-order"
          >
            <div className="order-grid">
              <div className="input-group">
                <label htmlFor="size">Dumpster Size</label>
                <select
                  id="size"
                  name="size"
                  required="true"
                  data-form-field-id="size"
                  className="form-control"
                >
                  <option value="10">10 Yard - Small Cleanup</option>
                  <option value="20" selected="true">
                    20 Yard - Standard Demo
                  </option>
                  <option value="30">30 Yard - Construction</option>
                  <option value="40">40 Yard - Industrial</option>
                </select>
              </div>
              <div className="input-group">
                <label htmlFor="delivery-date">Delivery Date</label>
                <input
                  type="date"
                  id="delivery-date"
                  name="date"
                  required="true"
                  data-form-field-id="delivery-date"
                  className="form-control"
                />
              </div>
              <div className="price-estimate">
                <span className="estimate-label">Estimated Price</span>
                <span className="estimate-value">$299.00</span>
              </div>
              <button
                id="thq_button_CYdR"
                name="button"
                type="submit"
                data-form-field-id="thq_button_CYdR"
                className="btn btn-xl btn-secondary"
              >
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M5 17a2 2 0 1 0 4 0a2 2 0 1 0-4 0m10 0a2 2 0 1 0 4 0a2 2 0 1 0-4 0"></path>
                    <path d="M5 17H3v-4M2 5h11v12m-4 0h6m4 0h2v-6h-8m0-5h5l3 5M3 9h4"></path>
                  </g>
                </svg>
                <span>
                  {' '}
                  Start Order
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </button>
            </div>
          </form>
        </div>
      </section>
      <section className="size-comparison">
        <div className="section-container">
          <div className="header-stack">
            <h2 className="section-title">Choose Your Firepower</h2>
            <p className="section-content">
              Compare our standard dumpster sizes to find the perfect fit for
              your debris.
            </p>
          </div>
          <div className="table-wrapper">
            <table className="comparison-grid">
              <thead>
                <tr>
                  <th>
                    <span>Dumpster Size</span>
                  </th>
                  <th>
                    <span>Weight Allowance</span>
                  </th>
                  <th>
                    <span>Overage Fee</span>
                  </th>
                  <th>
                    <span>Ideal Use Case</span>
                  </th>
                  <th>
                    <span>Action</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="size-cell">
                    <span>10 Yard</span>
                  </td>
                  <td>
                    <span>2 Tons Included</span>
                  </td>
                  <td>
                    <span>$95 / Ton</span>
                  </td>
                  <td>
                    <span>Garage cleanouts, heavy inert waste</span>
                  </td>
                  <td>
                    <button className="btn-outline btn btn-sm select-size-btn" data-size="10">
                      Select 10yd
                    </button>
                  </td>
                </tr>
                <tr>
                  <td className="size-cell">
                    <span>20 Yard</span>
                  </td>
                  <td>
                    <span>3 Tons Included</span>
                  </td>
                  <td>
                    <span>$90 / Ton</span>
                  </td>
                  <td>
                    <span>Roofing projects, home remodeling</span>
                  </td>
                  <td>
                    <button className="btn btn-sm btn-secondary select-size-btn" data-size="20">
                      Select 20yd
                    </button>
                  </td>
                </tr>
                <tr>
                  <td className="size-cell">
                    <span>30 Yard</span>
                  </td>
                  <td>
                    <span>4 Tons Included</span>
                  </td>
                  <td>
                    <span>$85 / Ton</span>
                  </td>
                  <td>
                    <span>New construction, major additions</span>
                  </td>
                  <td>
                    <button className="btn-outline btn btn-sm select-size-btn" data-size="30">
                      Select 30yd
                    </button>
                  </td>
                </tr>
                <tr>
                  <td className="size-cell">
                    <span>40 Yard</span>
                  </td>
                  <td>
                    <span>5 Tons Included</span>
                  </td>
                  <td>
                    <span>$80 / Ton</span>
                  </td>
                  <td>
                    <span>Commercial demo, estate cleanouts</span>
                  </td>
                  <td>
                    <button className="btn-outline btn btn-sm select-size-btn" data-size="40">
                      Select 40yd
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <section className="scheduling-flow">
        <div className="section-container">
          <div className="header-stack">
            <h2 className="section-title">Scheduling Simplified</h2>
            <p className="section-content">
              Flexible delivery and pickup options designed for busy
              contractors.
            </p>
          </div>
          <div className="horizontal-stepper">
            <div className="step-item">
              <div className="step-icon-box">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M8 2v4m8-4v4"></path>
                    <rect x="3" y="4" rx="2" width="18" height="18"></rect>
                    <path d="M3 10h18"></path>
                  </g>
                </svg>
              </div>
              <div className="step-text">
                <h3 className="section-subtitle">Pick Your Window</h3>
                <p className="section-content">
                  Select same-day or next-day delivery windows that fit your
                  crew&apos;s start time.
                </p>
              </div>
            </div>
            <div className="step-item">
              <div className="step-icon-box">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M16 5H3m13 7H3m8 7H3m12-1l2 2l4-4"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="step-text">
                <h3 className="section-subtitle">Placement Prep</h3>
                <p className="section-content">
                  Ensure a clear 60ft path for the truck and no overhead
                  obstructions like power lines.
                </p>
              </div>
            </div>
            <div className="step-item">
              <div className="step-icon-box">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2m10 0H9m10 0h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path>
                    <circle r="2" cx="17" cy="18"></circle>
                    <circle r="2" cx="7" cy="18"></circle>
                  </g>
                </svg>
              </div>
              <div className="step-text">
                <h3 className="section-subtitle">On-Call Pickup</h3>
                <p className="section-content">
                  Finished early? Text us for immediate haul-away. No waiting
                  around for days.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="quick-workflow">
        <div className="section-container">
          <div className="workflow-card">
            <div className="workflow-steps">
              <div className="wf-step">
                <span className="dumpster-rental-step-number">01</span>
                <p className="section-content">Choose Size</p>
              </div>
              <div className="wf-step">
                <span className="dumpster-rental-step-number">02</span>
                <p className="section-content">Schedule</p>
              </div>
              <div className="wf-step">
                <span className="dumpster-rental-step-number">03</span>
                <p className="section-content">Confirm</p>
              </div>
              <div className="wf-step">
                <span className="dumpster-rental-step-number">04</span>
                <p className="section-content">Delivery</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="trust-metrics">
        <div className="section-container">
          <div className="dumpster-rental-stats-grid">
            <div className="stat-card">
              <span className="dumpster-rental-stat-value">99%</span>
              <span className="dumpster-rental-stat-label">
                On-Time Delivery
              </span>
            </div>
            <div className="stat-card">
              <span className="dumpster-rental-stat-value">2hr</span>
              <span className="dumpster-rental-stat-label">
                Avg. Response Time
              </span>
            </div>
            <div className="stat-card">
              <span className="dumpster-rental-stat-value">15k+</span>
              <span className="dumpster-rental-stat-label">
                Dumpsters Delivered
              </span>
            </div>
            <div className="stat-card">
              <span className="dumpster-rental-stat-value">4.9/5</span>
              <span className="dumpster-rental-stat-label">
                Client Satisfaction
              </span>
            </div>
          </div>
        </div>
      </section>
      <section className="testimonials-rail">
        <div className="section-container rail-header">
          <h2 className="section-title">Contractor Approved</h2>
        </div>
        <div className="rail-track">
          <div className="dumpster-rental-testimonial-card">
            <div className="star-row">
              <svg
                width="20"
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                width="20"
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                width="20"
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                width="20"
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                width="20"
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21z"
                  fill="currentColor"
                ></path>
              </svg>
            </div>
            <p className="section-content">
              &quot;Panda is our go-to for all demolition sites. Their response
              time is unmatched in the city.&quot;
            </p>
            <div className="user-meta">
              <span className="user-name">Marcus T.</span>
              <span className="user-role">Site Super, MT Construction</span>
            </div>
          </div>
          <div className="dumpster-rental-testimonial-card">
            <div className="star-row">
              <svg
                width="20"
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                width="20"
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                width="20"
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                width="20"
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                width="20"
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21z"
                  fill="currentColor"
                ></path>
              </svg>
            </div>
            <p className="section-content">
              &quot;The instant ordering workflow saved me hours of phone calls.
              Highly recommend.&quot;
            </p>
            <div className="user-meta">
              <span className="user-name">Sarah L.</span>
              <span className="user-role">Homeowner</span>
            </div>
          </div>
          <div className="dumpster-rental-testimonial-card">
            <div className="star-row">
              <svg
                width="20"
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                width="20"
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                width="20"
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                width="20"
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                width="20"
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21z"
                  fill="currentColor"
                ></path>
              </svg>
            </div>
            <p className="section-content">
              &quot;Competitive pricing and no hidden fees. The 20-yard was
              exactly what we needed.&quot;
            </p>
            <div className="user-meta">
              <span className="user-name">David K.</span>
              <span className="user-role">Renovation Specialist</span>
            </div>
          </div>
        </div>
      </section>
      <section className="final-cta">
        <div className="cta-split-wrapper">
          <div className="cta-visual-column">
            <img
              alt="Industrial demolition equipment"
              src="https://images.pexels.com/photos/188679/pexels-photo-188679.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            />
            <div className="visual-overlay"></div>
          </div>
          <div className="cta-content-column">
            <h2 className="section-title">Large Scale Project?</h2>
            <p className="section-content">
              For long-term demolition contracts, multi-load sites, or oversized
              debris, our expert team provides custom logistics and pricing.
            </p>
            <div className="cta-action-group">
              <a href="/rfq-portal"><button className="btn-lg btn btn-secondary">
                Request Custom RFQ
              </button></a>
              <div className="contact-links">
                <a href="tel:+19544081674">
                  <div className="btn-link btn">
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Call Dispatch</span>
                  </div>
                </a>
                <a href="/contact">
                  <div className="btn-link btn">
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227q1.63.24 3.293.369V21l4.076-4.076a1.53 1.53 0 0 1 1.037-.443a48 48 0 0 0 5.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.4 48.4 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741z"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Contact Us</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="dumpster-rental-container2">
        <div className="dumpster-rental-container3">
          <Script
            html={`<script defer data-name="panda-demo-logic">
(function(){
  const sizeSelect = document.getElementById('size');
  const priceDisplay = document.querySelector('.estimate-value');

  const prices = {
    '10': 299,
    '20': 399,
    '30': 499,
    '40': 599
  };

  sizeSelect.addEventListener('change', (e) => {
    const val = e.target.value;
    if (prices[val]) {
      priceDisplay.textContent = \`\$\${prices[val]}.00\`;
      
      priceDisplay.style.transform = 'scale(1.1)';
      setTimeout(() => {
        priceDisplay.style.transform = 'scale(1)';
      }, 200);
    }
  });

  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const dateInput = document.getElementById('delivery-date');
  if (dateInput) {
    dateInput.min = tomorrow.toISOString().split('T')[0];
    dateInput.value = tomorrow.toISOString().split('T')[0];
  }

  // Select size buttons in comparison table -> set hero form size & scroll up
  const selectBtns = document.querySelectorAll('.select-size-btn');
  selectBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      window.openIframeModal('https://app.icans.ai/customer-portal/panda-demolition/book/');
    });
  });

  // Start Order form -> redirect to contact page with query params
  const orderForm = document.querySelector('.hero-quick-order');
  if (orderForm) {
    orderForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const size = sizeSelect.value;
      const date = document.getElementById('delivery-date').value;
      window.openIframeModal('https://app.icans.ai/customer-portal/panda-demolition/book/');
    });
  }

  const track = document.querySelector('.rail-track');
  let isDown = false;
  let startX;
  let scrollLeft;

  if (track) {
    track.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });
    track.addEventListener('mouseleave', () => { isDown = false; });
    track.addEventListener('mouseup', () => { isDown = false; });
    track.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX) * 2;
      track.scrollLeft = scrollLeft - walk;
    });
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default DumpsterRental
